import { render, staticRenderFns } from "./new_details.vue?vue&type=template&id=2f1d1cba&scoped=true&"
import script from "./new_details.vue?vue&type=script&lang=js&"
export * from "./new_details.vue?vue&type=script&lang=js&"
import style0 from "./new_details.vue?vue&type=style&index=0&id=2f1d1cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d1cba",
  null
  
)

export default component.exports